import { CapitalizeEachWord } from 'common/utils';

function toSlug(str) {
  return String(str || '')
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/^_+|_+$/g, '');
}

/**
 * Localized component property field label from machine-builder metadata schema.
 *
 * @param {function} t - i18next `t`
 * @param {object} [i18n] - i18next instance (`exists` for key lookup)
 * @param {string} propKey - schema property key
 * @param {{ display_name?: string }} [propDef] - schema property definition
 * @returns {string}
 */
export function getComponentPropertyFieldDisplayName(t, i18n, propKey, propDef) {
  const base = 'assets.create.componentPropertyFields';
  const candidates = [propKey, toSlug(propDef && propDef.display_name)].filter(Boolean);

  const matchedKey = candidates.find((key) => {
    const translationKey = `${base}.${key}`;
    return i18n && typeof i18n.exists === 'function' && i18n.exists(translationKey);
  });
  if (matchedKey) {
    return t(`${base}.${matchedKey}`);
  }

  return t(`${base}.${propKey}`, {
    defaultValue:
      (propDef && propDef.display_name)
      || CapitalizeEachWord(String(propKey).replace(/_/g, ' ')),
  });
}
